/**
 * Utility functions for the undo/redo system
 */

import { IBody } from '@makyoapp/makyo-sdk/models/AppBuilder.js'

/**
 * Generate a unique ID for undo actions
 */
export function generateUndoActionId(): string {
  return `undo_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
}

/**
 * Get a friendly component type name from its numeric type
 */
export function getComponentLabel(component: IBody): string {
  if (!component) return 'Component'
  return component._Title ? `${component._Title} (${component._ComponentID})` : component._ComponentID
}

/**
 * Create a coalescing key for component updates
 * This allows rapid consecutive updates to the same component property to be merged
 */
export function createCoalescingKey(target: string, targetId: string, property?: string): string {
  return property ? `${target}:${targetId}:${property}` : `${target}:${targetId}`
}
